var _path, _rect, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 6.68629 6.68629 4 10 4H30C33.3137 4 36 6.68629 36 10V14H4V10Z",
    fill: "#FFCC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14,
    x2: 35,
    y2: 14,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1922 19.5L13.1172 21.3V23.34L15.1272 22.14V30H17.0172V19.5H16.1922ZM23.1081 19.38C20.6031 19.38 19.2381 21.39 19.2381 24.75C19.2381 28.11 20.6031 30.12 23.1081 30.12C25.6131 30.12 26.9781 28.11 26.9781 24.75C26.9781 21.39 25.6131 19.38 23.1081 19.38ZM23.1081 21.12C24.4881 21.12 25.1181 22.41 25.1181 24.75C25.1181 27.09 24.4881 28.38 23.1081 28.38C21.7281 28.38 21.0981 27.09 21.0981 24.75C21.0981 22.41 21.7281 21.12 23.1081 21.12Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar10);
export default __webpack_public_path__ + "static/media/calendar-10.3cb0f2aed161ca2b7c8579dd3bb8f87e.svg";
export { ForwardRef as ReactComponent };